@let isExpanded = !isCollapsed;
<div
  class="sidebar"
  data-testid="sidebar"
  (mouseleave)="onNavMouseLeave()"
  [class.expanded]="isExpanded"
>
  <nav
    class="modules"
    (mouseenter)="onNavItemMouseEnter()"
  >
    @if (loadingMenuItens()) {
      @if (!isCollapsed) {
        <div
          class="skeleton-modules"
          data-testid="sidebar-loading"
        >
          @for (g of [0, 1, 2]; track g) {
            <div class="skeleton-group" [style.--g]="g">
              <div class="skeleton-module-header skeleton-pulse"></div>
              @for (r of [0, 1, 2]; track r) {
                <div class="skeleton-nav-row skeleton-pulse" [style.--r]="g * 3 + r"></div>
              }
            </div>
          }
        </div>
      } @else {
        <button
          class="oc button icon small skeleton-button"
          data-testid="sidebar-loading"
        ></button>
        <button class="oc button icon small skeleton-button delay-1"></button>
        <button class="oc button icon small skeleton-button delay-2"></button>
        <button class="oc button icon small skeleton-button delay-3"></button>
        <div class="divider"></div>
        <button class="oc button icon small skeleton-button delay-4"></button>
      }
    } @else {
      <div class="module-buttons">
        @for (item of navigationItems(); track item.id; let i = $index) {
          @let hasChildren = item.children.length > 0;
          @let itemOpen = isExpanded && hasChildren && isItemExpanded(item.id);

          <div
            class="module"
            data-testid="sidebar-module"
            [attr.data-module-name]="item.name"
            [class.module-open]="itemOpen"
            [style.--stagger]="i"
          >
            @if (hasChildren) {
              <button
                type="button"
                class="module-button"
                data-testid="sidebar-module-button"
                [attr.data-module-name]="item.name"
                [class.active]="!isExpanded && isModuleSelected(item)"
                (click)="onModuleButtonClick(item)"
              >
                <span class="material-symbols-outlined module-icon">{{ item.icon }}</span>
                @if (isExpanded) {
                  <span class="module-label">{{ translateService.getTranslation(item.nameCode ?? item.name) }}</span>
                  <span class="material-symbols-outlined module-chevron">expand_more</span>
                }
              </button>
              @if (!isExpanded && isModuleSelected(item)) {
                <div class="has-module-content-line"></div>
              }
            } @else {
              <a
                class="module-button"
                data-testid="sidebar-module-button"
                [attr.data-module-name]="item.name"
                [class.active]="isModuleSelected(item)"
                [routerLink]="item.name"
              >
                <span class="material-symbols-outlined module-icon">{{ item.icon }}</span>
                @if (isExpanded) {
                  <span class="module-label">{{ translateService.getTranslation(item.nameCode ?? item.name) }}</span>
                }
              </a>
              @if (isModuleSelected(item)) {
                <div class="has-module-content-line"></div>
              }
            }

            @if (isExpanded && hasChildren) {
              <div class="module-submenu">
                <div class="module-submenu-inner">
                  @for (child of item.children; track child.id) {
                    <app-sidebar-nav-group
                      [item]="child"
                      [depth]="0"
                      [favoriteIds]="favoriteIds()"
                      [siblingIds]="childIds(item.children)"
                    />
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      @if (!isExpanded) {
        <div class="divider"></div>
        <span class="material-symbols-outlined favs-icon">favorite</span>
      } @else {
        <app-sidebar-favorites />
      }
    }
  </nav>
  <div class="bottom">
    <div
      class="preferences"
      [class.expanded]="isExpanded"
    >
      <!-- Alterar idioma -->
      <button
        type="button"
        class="pref-button lang-button"
        oc-dropdown
        [ocDropdownMenu]="langMenu"
        [attr.aria-label]="translateService.getTranslation('OTIMUS4410')"
        [attr.title]="translateService.getTranslation('OTIMUS4410')"
      >
        <span class="material-symbols-outlined pref-icon">language</span>
        @if (isExpanded) {
          <span class="pref-label">{{ currentLangLabel() }}</span>
        }
      </button>

      <oc-dropdown-menu-content #langMenu="ocDropdownMenuContent">
        @for (l of languages; track l.code) {
          <oc-dropdown-menu-item
            [inset]="l.code !== currentLang()"
            (click)="changeLanguage(l.code)"
          >
            @if (l.code === currentLang()) {
              <span class="material-symbols-outlined lang-check">check</span>
            }
            <span>{{ l.label }}</span>
          </oc-dropdown-menu-item>
        }
      </oc-dropdown-menu-content>

      <!-- Alterar tema -->
      <button
        type="button"
        class="pref-button theme-button"
        oc-dropdown
        [ocDropdownMenu]="themeMenu"
        [attr.aria-label]="translateService.getTranslation('OTIMUS4411')"
        [attr.title]="translateService.getTranslation('OTIMUS4411')"
      >
        <span class="material-symbols-outlined pref-icon">palette</span>
      </button>

      <oc-dropdown-menu-content #themeMenu="ocDropdownMenuContent">
        <oc-dropdown-menu-item
          [inset]="currentTheme() !== 'light'"
          (click)="changeTheme('light')"
        >
          @if (currentTheme() === 'light') {
            <span class="material-symbols-outlined lang-check">check</span>
          }
          <!-- Claro -->
          <span>{{ translateService.getTranslation('OTIMUS4412') }}</span>
        </oc-dropdown-menu-item>
        <oc-dropdown-menu-item
          [disabled]="true"
          [inset]="true"
        >
          <!-- Escuro -->
          <span>{{ translateService.getTranslation('OTIMUS4413') }}</span>
          <!-- em breve -->
          <span class="soon-badge">{{ translateService.getTranslation('OTIMUS4414') }}</span>
        </oc-dropdown-menu-item>
      </oc-dropdown-menu-content>

      <!-- Desafixar aba lateral (OTIMUS4415) / Fixar aba lateral (OTIMUS4416) -->
      <button
        type="button"
        class="pref-button pin-button"
        data-testid="sidebar-collapse-button"
        (click)="toggle()"
        [attr.aria-label]="translateService.getTranslation(isPinned ? 'OTIMUS4415' : 'OTIMUS4416')"
        [attr.title]="translateService.getTranslation(isPinned ? 'OTIMUS4415' : 'OTIMUS4416')"
      >
        <span class="material-symbols-outlined pref-icon">
          {{ isPinned ? 'left_panel_close' : 'left_panel_open' }}
        </span>
      </button>
    </div>
    <small
      class="version"
      data-testid="sidebar-version"
      >{{ systemVersion() }}</small
    >
  </div>
</div>
